export const createSagasTrigger = <T>(actionType: string) => ({
    trigger: actionType,
    run: (payload: T) => ({
      type: actionType,
      payload,
    }),
  })